export * from './domain';
export * from './testkit';
export * from './builders';
export var createOmnichannelDashboardApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/dashboard/omnichannel");
    return {
        getTableData: function (dashboardDto) { return http.post("".concat(url), dashboardDto); },
        getDashboardOverview: function (dashboardOverviewDto) { return http.post("".concat(url, "/overview"), dashboardOverviewDto); },
    };
};
//# sourceMappingURL=index.js.map